// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ReadyToImport, {
  useReady,
} from '../../../../components/Ready/externalIdImport/ReadyToImport';
import useFormikOrchestration from '../../../../components/useFormikOrchestration';
import { ProgressIndicator, useLink } from './_config';

export default function Ready({ match }) {
  const link = useLink('ready');

  const history = useHistory();
  const { workspaceId, importId } = match.params;
  const props = useReady({ workspaceId, importId });
  const { triggerSubmit, setFormikContext } = useFormikOrchestration();

  /**
   * @param {object} options
   */
  async function handleSubmit(options) {
    await props.onSubmit(options);
    history.push(link.next());
  }

  return (
    <Layout>
      <ProgressIndicator step="ready" />
      <PageHeader>
        <PageTitle>
          <Trans>Ready to import</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>All your data is valid and ready to import.</Trans>
        </PageSubtitle>
      </PageHeader>

      <Main>
        <ReadyToImport
          {...props}
          setFormikContext={setFormikContext}
          // Overrides props.onSubmit
          onSubmit={handleSubmit}
        />
      </Main>

      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton disabled={props.isSubmitting} onClick={triggerSubmit}>
          <Trans>Import data</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}
